import DefaultCategoryGuides from '@uswitch/ev-components/lib/components/modules/category-guides-module/default'
import HtmlSitemapCategoryGuides from '@uswitch/ev-components/lib/components/modules/category-guides-module/html-sitemap'
import React from 'react'

import CategoryGuidesModule from '../../category-guides-module'

const CategoryGuidesModuleWrapper = (props) => {
  switch (props?.variant) {
    case 'featured':
      return <CategoryGuidesModule {...props} />
    case 'html-sitemap':
      return <HtmlSitemapCategoryGuides {...props} />
    default:
      return <DefaultCategoryGuides {...props} />
  }
}

export default CategoryGuidesModuleWrapper
